<template>
  <div class="content-body" id="transport-request">
    <div class="row match-height"> 
      <div class="col-md-12">
        <div class="card" >          
				  <div class="card-header">
					  <h4 v-if="userRole == 'admin' || userRole == 'logist'" class="card-title"><i class="icon-eye6"></i> {{$t('titles.transport_request')}}</h4>
					  <h4 v-if="userRole == 'user'" class="card-title"><i class="icon-eye6"></i> {{$t('table.my-orders')}}</h4>
          </div>
          <div class="card-body " >
          <!------------------------------- start filter block  -------------------------->
            <div class="content-filter">
                <div class="card collapse-icon accordion-icon-rotate">
                  <div id="headingCollapse41" class="card-header bg-success">
                      <a data-toggle="collapse" href="#collapse41" aria-expanded="true" aria-controls="collapse41" class="card-title lead white">{{ $t('button.display-parametrs')}}</a>
                  </div>
                  <div id="collapse41" role="tabpanel" aria-labelledby="headingCollapse41" class="border-success card-collapse collapse show in" aria-expanded="true">
                      <div class="card-content">
                          <div class="card-body mb-2">
                              <form class="form filter-form">
                                <div class="form-body">
                                    <div class="row" >                     
                                      <div class="col-md-3 col-sx-6">
                                        <div class="form-group">
                                          <fieldset class="form-group position-relative has-icon-left mb-0">
                                          <div class="input-group">
                                              <span class="input-group-addon">{{ $t('input.date-from')}}</span>
                                              <input v-model="report.dataFrom" 
                                                type="date" 
                                                class="form-control" 
                                                id="datefrom" 
                                                name="date" />
                                            </div>
                                          </fieldset>
                                        </div>
                                      </div>
                                      <div class="col-md-3 col-sx-6">
                                        <div class="form-group">
                                          <fieldset class="form-group position-relative has-icon-left mb-0">
                                          <div class="input-group">
                                              <span class="input-group-addon">{{ $t('input.date-to')}}</span>
                                              <input v-model="report.dataTo" 
                                                type="date" 
                                                class="form-control" 
                                                id="dateto" 
                                                name="date" />
                                            </div>
                                          </fieldset>
                                        </div>
                                      </div>
                                      <div class="col-md-3 col-sx-6" v-if="userRole == 'admin' || userRole == 'logist'">
                                        <div class="form-group">
                                          <fieldset class="form-group position-relative has-icon-left mb-0"  >
                                            <select class="form-control border-primary" v-model="report.frontoffice">
                                                <option value=""></option>
                                                  <option value="BELARUS">BELARUS</option>
                                                  <option value="FRANCE">FRANCE</option>
                                                  <option value="GERMANY">GERMANY</option>
                                                  <option value="MENA">MENA</option>
                                                  <option value="POLAND">POLAND</option>
                                                  <option value="RUSSIA">RUSSIA</option>
                                                  <option value="UA">UA</option>
                                                  <option value="UK">UK</option>
                                              </select>
                                              <div class="form-control-position">
                                                <i class="icon-clipboard2"></i>
                                              </div>
                                          </fieldset>
                                        </div>
                                      </div>
                                      <div class="col-md-3 col-sx-6">
                                        <div class="form-group">
                                          <!-- <label for="comment">{{$t('button.report-form')}}</label> -->
                                          <button type="button" class="btn btn-success"  @click="reportSee()">
                                            {{$t('button.report-form')}}
                                          </button>
                                          <!-- <button  v-on:click="saveToExcel(1)"  
                                                  type="button" 
                                                  class="btn btn-warning ">
                                                  <i class="icon-floppy-disk"></i>
                                        </button> -->
                                        </div>
                                      </div>
                                  </div>
                                </div>							
                            </form>
                            
                            <div class="row">
                              <div class="col-md-6 pl-2">
                                <div class="form-group row">
                                    <label for="concept" class="col-sm-3 control-label" style="width: 90% !important;" >{{ $t('label.findorder')}}</label>
                                    <div class="col-md-11">
                                        <div class="input-group ">
                                          <autocomplete  :suggestions="listOrder" 
                                          v-model="selection" 
                                          @input="getListOrder" 
                                          ria-hidden="true"
                                          v-tooltip.top-center="selectorder">
                                          </autocomplete>
                                          <div class="input-group-append">
                                              <button  v-on:click="findOrder()"  
                                          type="button" 
                                          class="btn btn-primary">{{ $t('button.find')}}
                                          </button>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                              <div class="col-md-6 pl-2">
                                <div class="form-group row">
                                    <label for="concept" class="col-sm-3 control-label" style="width: 90% !important;" >{{ $t('label.findcustoms-order')}}</label>
                                    <div class="col-md-11">
                                        <div class="input-group ">
                                         <autocomplete  :suggestions="listCustomsOrder" 
                                          v-model="selectionCustomsOrder" 
                                          @input="getListCustomsOrder" 
                                          ria-hidden="true"
                                          v-tooltip.top-center="selectorder">
                                          </autocomplete>
                                          <div class="input-group-append">
                                              <button  v-on:click="findOrder()"  
                                              type="button" 
                                              class="btn btn-primary">{{ $t('button.find')}}
                                          </button> 
                                          </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            
                              
                            </div>                          


                          </div>
                      </div>
                  </div>
                  
              </div>
            </div>  
          <!------------------------------- and filter block  -------------------------->  

         <!-- start desc order   -->
         <div name="fade" v-if="result">
            <div class="row mb-2 pl-2" >
              <div class="col-md-2">
                  <label  for="concept" class="control-label" >{{ $t('label.find')}}</label>
                </div>
                <div class="col-md-5">
                  <input   
                          type="text"
                          name="keysearch"
                          v-model="keysearch"
                          @input="filterTable"
                          @change="filterTable()"
                          v-tooltip.top-center="reportfind"
                          class="form-control" />

              </div>
              
          </div>  
          <div class="row" ref="desc"  id="desc">
            <div class="d-flex flex-row-reverse"  v-if="descTablesData">
               <div class="p-2">
                 <span class="link " @click="descTablesData = !descTablesData"><font-awesome-icon class="sicon" icon="window-close" /></span>
               </div>
              
            </div>
            
             <div class="col-md-4" v-if="descTablesData">
                <ul class="list-group">
                  <li class="list-group-item">{{ $t('table.order')}}: <span class="badge badge-secondary">{{descTablesData.order}}</span></li>
                  <li class="list-group-item">{{ $t('table.place')}}: <span class="order-desc">{{descTablesData.place}}</span></li>
                  <li class="list-group-item">{{ $t('table.status')}}: <span class="badge badge-secondary">{{descTablesData.status}}</span></li>
                  <!-- <li class="list-group-item">{{ $t('table.export')}}: <span class="badge badge-secondary">{{descTablesData.export}}</span></li> -->
                  <li class="list-group-item">{{ $t('table.office-id')}}: <span class="badge badge-secondary">{{descTablesData.frontOffice}}</span></li>
                  <!-- <li class="list-group-item">{{ $t('table.direction')}}: <span class="order-desc">{{descTablesData.paragraph}}</span></li> -->
                  <!-- <li class="list-group-item">{{ $t('table.expected-manufacturing-day')}} <span class="badge badge-secondary">{{descTablesData.expectedDateDeliveryWarehouse}}</span></li>
                  <li class="list-group-item">{{ $t('table.manufacturing-day-fact')}} <span class="badge badge-secondary">{{descTablesData.actualDateDelivery}}</span></li>
                  <li class="list-group-item">{{ $t('table.expected-dispatch-day')}} <span class="badge badge-secondary">{{descTablesData.expectedDownloadDate}}</span></li>
                  <li class="list-group-item">{{ $t('table.dispatch-day-fact')}} <span class="badge badge-secondary">{{descTablesData.actualUploadDate}}</span></li>
                  <li class="list-group-item">{{ $t('table.expected-customs-clearence-date')}} <span class="badge badge-secondary">{{descTablesData.expectedDateRemuneration}}</span></li>
                  <li class="list-group-item">{{ $t('table.expected-delivery-date')}} <span class="badge badge-secondary">{{descTablesData.expectedDeliveryDate}}</span></li>
                  <li class="list-group-item">{{ $t('table.planned-delivery-date')}} <span class="badge badge-secondary">{{descTablesData.scheduledDelivery}}</span></li>
                  <li class="list-group-item">{{ $t('table.delivered-fact')}} <span class="badge badge-secondary">{{descTablesData.unloadingFact}}</span></li>
                  <li class="list-group-item">{{ $t('table.body-size')}} <span class="badge badge-secondary">{{descTablesData.bodySize}}</span></li>
                  <li class="list-group-item">{{ $t('table.comments')}} <span class="badge badge-secondary">{{descTablesData.comment}}</span></li>
                  <li class="list-group-item">{{ $t('table.commentTc')}} <span class="badge badge-secondary">{{descTablesData.commentTc}}</span></li>
                  <li class="list-group-item">{{ $t('table.typeTS')}} <span class="badge badge-secondary">{{descTablesData.typeTS}}</span></li> -->
						</ul>
             </div>
             <div class="col-md-4" v-if="descTablesData">
                <ul class="list-group">
                    <li class="list-group-item">{{ $t('table.direction')}}: <span class="order-desc">{{descTablesData.paragraph}}</span></li>
                   <li class="list-group-item">{{ $t('table.expected-manufacturing-day')}}: <span class="badge badge-secondary">{{descTablesData.expectedDateDeliveryWarehouse}}</span></li>
                  <li class="list-group-item">{{ $t('table.manufacturing-day-fact')}}: <span class="badge badge-secondary">{{descTablesData.actualDateDelivery}}</span></li>
                  <li class="list-group-item">{{ $t('table.expected-dispatch-day')}}: <span class="badge badge-secondary">{{descTablesData.expectedDownloadDate}}</span></li>
                  
                 
						</ul>
             </div>
             <div class="col-md-4" v-if="descTablesData">
                <ul class="list-group">
                  <li class="list-group-item">{{ $t('table.dispatch-day-fact')}}: <span class="badge badge-secondary">{{descTablesData.actualUploadDate}}</span></li>
                  <!-- <li class="list-group-item">{{ $t('table.expected-customs-clearence-date')}}: <span class="badge badge-secondary">{{descTablesData.expectedDateRemuneration}}</span></li> -->
                  <li class="list-group-item">{{ $t('table.expected-delivery-date')}}: <span class="badge badge-secondary">{{descTablesData.expectedDeliveryDate}}</span></li>
                  <li class="list-group-item">{{ $t('table.planned-delivery-date')}}: <span class="badge badge-secondary">{{descTablesData.scheduledDelivery}}</span></li>
                  <li class="list-group-item">{{ $t('table.delivered-fact')}}: <span class="badge badge-secondary">{{descTablesData.unloadingFact}}</span></li>
                  <!-- <li class="list-group-item">{{ $t('table.body-size')}}: <span class="badge badge-secondary">{{descTablesData.bodySize}}</span></li> -->
                  <!-- <li class="list-group-item">{{ $t('table.comments')}}: <span class="order-desc">{{descTablesData.comment}}</span></li>
                  <li class="list-group-item">{{ $t('table.commentTc')}}: <span class="order-desc">{{descTablesData.commentTc}}</span></li> -->
                  <!-- <li class="list-group-item">{{ $t('table.typeTS')}}: <span class="badge badge-secondary">{{descTablesData.typeTS}}</span></li> -->
						</ul>
             </div>


          </div>
        </div>
          <!-- and desc order -->
    <!-- ___________main-tables    -->
            <div class="main-tables mobileTbl table-responsive p-1 outer" v-if="result">
                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                        <thead>
                            <tr>     
                                <th style="vertical-align: middle;">{{ $t('table.order')}}</th>                                                           
                                <th style="vertical-align: middle;">{{ $t('table.direction')}}</th>
                                <th style="vertical-align: middle;">{{ $t('table.expected-delivery-date')}}</th>
                                <th style="vertical-align: middle;"></th>
                                <th style="vertical-align: middle;">{{ $t('table.on-map')}}</th>
                                
                                <!-- <th style="vertical-align: middle;">{{ $t('table.comments')}}</th>                         -->
                            </tr>
                        </thead>                                                       
                        <tbody>                              
                            <tr class="marginTR" v-for="(item) in result" :key="item.number">                                            
                                <td :data-title="$t('table.order')"> <span class="action-icon link" @click="showOrdertDetail(item)">{{item.order}}</span></td>                                            
                                <td :data-title="$t('table.status')"> {{item.paragraph}}</td>                                            
                                <td :data-title="$t('table.direction')"> {{item.expectedDeliveryDate}}<span  class="action-icon " @click="showTransportDetail(item)"></span></td>     
                                <td><a href="" ></a><font-awesome-icon icon="info" class="cursor"  @click="goToRef(item)"/> </td>                                        
                                <td :data-title="$t('table.on-map')"><a href="#"  class="btn btn-primary" v-on:click="showModalMap(item.order)">{{ $t('label.display')}}</a></td> 
                                <!-- <td :data-title="$t('table.comments')"> 
                                  <input type="text"
                                    name="comment"
                                    v-model="item.comment"
                                    @change="changeComment(item.tc, item.comment)"
                                    class="form-control" />
                                  
                                  </td>                                             -->                                                                 
                            </tr>   
                        </tbody>
                    </table>
            </div>
            <!-- ____________________and main tables -->
          </div>
          <!-------------------------------- and card body ----------------------->
        </div>
      </div>
    </div>
     <!-- Modal -->
          <vue-modal :on-close="closeModalMap"
                   name="map-modal">
            <h3 slot="header" style="text-align:center">{{ $t('label.transport-location')}}</h3>
            <div class="row row-map">
                <GmapMap
                        :center="center"
                        :zoom="11"
                        map-type-id="terrain"
                        style="height: 600px">
                    <GmapMarker
                            :key="index"
                            v-for="(m, index) in list"
                            :position="m"
                            :clickable="true"
                            :draggable="true"
                    />
                </GmapMap>
            </div>
            <br/>
            <div class="row">
                <div class="col-md-12 mb-3">
                </div>
            </div>
        </vue-modal>
    <!-- And Modal -->
    <!-- Modal order-detail -->
 <vue-modal :on-close="closeModal('order-detail')"  name="order-detail" :adaptive="true" :scrollable="true" :width="modalwidth" >
    <!-- <h3 slot="header" style="text-align:center">{{$t('link.warrant-pallets')}}</h3> -->
    <div class="row ">
      <div name="fadeTranscriptOrder1">
          <div v-if="showTableTranscriptOrder" >
              <div class="row">
                  <div class="col-sm-6 col-md-5">
                      <label for="concept" class="col-sm-3 control-label text-bold-500" style="width: 90% !important;">{{ $t('label.search-nomenclature-pallets')}}</label>
                  </div>
                  <div class="col-sm-6 col-md-4">
                      <autocomplete  :suggestions="listNomenclature"
                                      v-model="selectionNumenclature"
                                      @input="getListNomenclature"
                                      ria-hidden="true"
                                      v-tooltip.top-center="selectarticle">
                      </autocomplete>
                  </div>
                  <div class="col-xs-3">
                      <button  v-on:click="findNomenclatureByPallet()"
                              type="button"
                              class="btn btn-danger">{{ $t('button.find')}}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <!-- <button  v-on:click="saveToExcel(2)"  
                              type="button" 
                              class="btn btn-warning ">
                              <i class="icon-floppy-disk"></i>
                  </button> -->
                  </div>
              </div>
              <br>

              <!-- <a href="#" v-on:click="showTableMain()" class="btn btn-primary btn-min-width mr-1 mb-1">{{ $t('link.back-orders')}}</a> -->
               <!-- ___________main-tables    -->
            <div class="main-tables mobileTbl table-responsive p-1" >
                    <table class="table table-hover mb-0 loading modal-detail" cellspacing="0" >
                         <thead style="text-aligin:center;"  :class="{ 'is-fixed': isFixed }">
                            <tr>
                              <th style="vertical-align: middle;">{{ $t('table.number')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.order')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.orderForProduction')}}</th>                             
                              <th style="vertical-align: middle;">{{ $t('table.externalorder')}}</th>                             
                            </tr>
                        </thead>                                                     
                         <tbody class="table100-body js-pscroll">
                           <tr class="marginTR" v-for="(item,index) in dataFields" :key="index">                                           
                                <td :data-title="$t('table.number')"> {{item.number}}</td>                                            
                                <td :data-title="$t('table.order')"> {{item.order}}<br><a href="#" class="action-icon link"  
                            v-on:click="showOrderInPallet(item)" >{{ $t('link.warrant-pallets')}}</a></td>                                            
                                <td :data-title="$t('table.orderForProduction')"><a href="#" class="action-icon link"  
                            v-on:click="showOrderSumItem(item)" >{{item.orderForProduction}}</a> </td>                                            
                                <td :data-title="$t('table.externalorder')"> {{item.externalorder}}</td>                                            
                               
                            </tr>                 
                       </tbody>
                    </table>
            </div>
            <!-- ____________________and main tables -->

              <!-- <my-table :dataFields="dataFields"
                      @hrefclickOrderByPallet="clickNextTable"
                      @hrefclickTranscriptOrder="clickNextTableTranscriptOrder">
              </my-table> -->
          </div>
      </div>             
    </div>
   
</vue-modal>
    <!-- And Modal -->


       <!-- Modal order-in-pallete -->
 <vue-modal :on-close="closeModal('order-in-pallet')" id="order-in-pallet"  name="order-in-pallet" :adaptive="true" :scrollable="true" :width="modalwidth"  >
    <h3 slot="header" style="text-align:center">{{$t('link.warrant-pallets')}}</h3>
    <div class="row ">
      <div name="fadeTranscriptOrder2">
          <div v-if="showTableTranscriptOrderByPallet" >
            <div class="main-tables mobileTbl table-responsive outer" >
                <table class="table  mb-0 loading order-in-pallet" cellspacing="0" >
                      <thead style="text-aligin:center;"  :class="{ 'is-fixed': isFixed }">
                        <tr>
                              <th class="smal" style="vertical-align: middle;">{{ $t('table.number')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.orders')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.point')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.articul')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.nomenklature')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.quantity')}}</th>
                        </tr>
                    </thead>                                                     
                      <tbody class="table100-body js-pscroll">
                        <tr class="marginTR" v-for="(item) in dataFieldsOrderByPallet" :key="item.number">                                           
                            <td class="smal" :data-title="$t('table.number')"> {{item.number}}</td>                                            
                            <td :data-title="$t('table.orders')"> {{item.orders}}</td>                                            
                            <td :data-title="$t('table.point')"> {{item.point}}</td>                                            
                            <td :data-title="$t('table.articul')"> {{item.articul}}</td>                                            
                            <td :data-title="$t('table.nomenklature')"> {{item.nomenklature}}</td>                                            
                            <td :data-title="$t('table.quantity')"> {{item.quantity}}</td>                                             
                        </tr>                 
                    </tbody>
                </table>
            </div>
            <!-- ____________________and main tables --> 
          </div>
      </div>
    </div>   
</vue-modal>
    <!-- And modal order-in-pallete -->
    <!-- Modal order-sub-desk -->
 <vue-modal :on-close="closeModal('order-sub-desk')"  name="order-sub-desk" :adaptive="true" :scrollable="true"  >
    <!-- <h3 slot="header" style="text-align:center"></h3> -->
    <div class="row ">
      <div name="fadeTranscriptOrder3">
          <div >
            <div class="main-tables mobileTbl table-responsive p-1 outer" >
                <table class="table table-hover mb-0 loading order-sub-desk" cellspacing="0" >
                      <thead style="text-aligin:center;"  :class="{ 'is-fixed': isFixed }">
                        <tr>
                              <th style="vertical-align: middle;">{{ $t('table.number')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.orders')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.artikul')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.nomenklature')}}</th>
                              <th style="vertical-align: middle;">{{ $t('table.quantity')}}</th>
                              
                        </tr>
                    </thead>                                                     
                      <tbody class="table100-body js-pscroll">
                        <tr class="marginTR" v-for="(item) in dataFieldsOrderClient" :key="item.number">                                           
                            <td :data-title="$t('table.number')"> {{item.number}}</td>                                            
                            <td :data-title="$t('table.orders')"> {{item.orders}}</td>                                         
                            <td :data-title="$t('table.artikul')"> {{item.artikul}}</td>                                         
                            <td :data-title="$t('table.nomenklature')"> {{item.nomenklature}}</td>                                            
                            <td :data-title="$t('table.quantity')"> {{item.quantity}}</td>                                             
                        </tr>                 
                    </tbody>
                </table>
            </div>
            <!-- ____________________and main tables --> 
          </div>
      </div>
    </div>   
</vue-modal>
    <!-- And modal order-in-pallete -->
  </div> 
</template>

<script>
import autocomplete from "./../components/autocomplete";
import MyTable from './../components/table';
import fileDownload from 'js-file-download';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
// library.add(faUserSecret)

export default {
  name: "transport_tender",
  data() {
    return {
      modalwidth:"80%",
      showDescTables:null,
      descTablesData:null,
      list: [],
      center: { lat: 50.761871, lng: 25.3562243 },

      tasksNotCompletedNew: this.tasksNotCompleted,
      tasksCompletedNew: this.tasksCompleted,

      selectUnitModal: false,
      loading: false,
      collapsed: true,
      filterfield: true,
      selectionfield: true,
      showTable: true,
      showTableTranscriptOrder: false,
      showTableTranscriptOrderDetalis: false,
      showTableTranscriptOrderClientDetalis: false,
      showTableTranscriptOrderByPallet: false,
      showTableNomenclatureByPallet: false,

      isFixed: false,

      open: false,
      current: 0,
      listOrder: [],
      listCustomsOrder: [],
      listNomenclature: [],
      selection: "",
      selectionOrder: "",
      selectionCustomsOrder: "",
      selectionNumenclature: "",

      keysearch: "",
      result: null,
      oldresult: [],
      report: {
        dataFrom: "",
        dataTo: "",
        numberOrder: null,
        frontoffice: null
      },

      customsfields: [],
      dataFields: [],
      dataFields2: [],
      oldDataFields: [],
      oldDataFields2: [],
      sortFields: [],
      dataFieldsOrderClient: [],
      oldDataFieldsOrderClient: [],
      dataFieldsOrderByPallet: [],
      oldDataFieldsOrByPallet: [],
      dataFieldsNomenclatureByPallet: [],
      oldDataFieldsNomenclatureByPallet: [],
      colums: {
        order: true,
        export: false,
        frontOffice: false,
        paragraph: true,
        status: false,
        direction: true,
        place: true,
        expectedDateDeliveryWarehouse: true,
        actualDateDelivery: true,
        expectedDownloadDate: true,
        actualUploadDate: true,
        expectedDateRemuneration: true,
       // misinterpretedFact: true,
        controlPointPlan: true,
        checkPointFact: true,
        expectedDeliveryDate: true,
        scheduledDelivery: true,
        unloadingFact: true,
        bodySize: false,
        comment: true,
        commentTc: false,
        typeTS:false,
      },

      sortOrderBy: 0,
      sortOrders: {
        order: 0,
        export: 0,
        frontOffice: 0,
        paragraph: 0,
        expectedDateDeliveryWarehouse: 0,
        actualDateDelivery: 0,
        expectedDownloadDate: 0,
        actualUploadDate: 0,
        expectedDateRemuneration: 0,
    //    misinterpretedFact: 0,
        checkPointFact: 0,
        expectedDeliveryDate: 0,
        scheduledDelivery: 0,
        unloadingFact: 0,
        bodySize: 0,
        typeTS: 0,
      },

      order: "Order - order number",
      exp:
        "Export/Import - indication of the direction of the order transportation",
      frontOffice: "Front office",
      destination: "Destination - the address of the delivery of the goods",
      expected:
        "Expected date of delivery of the goods to the warehouse is the expected date for the production of the order",
      actually:
        "Actually, it was handed over to the warehouse - the actual date of the order production",
      expectedshipping:
        "Expected shipping date is the download date expected by the manager",
      actualdownload:
        "Actual download date is the actual upload date specified by the logist",
      expecteddate:
        "Expected date of customs clearing - expected date of customs clearing by logist",
      customclearing:
        "Custom  clearing done - actual date from custom data base",
      controlpoint:
        "Control point plan - for the EU - scheduled date of the border crossing; for containers - scheduled date of the ship extractor",
      controlpointfact:
        "Control point fact - for the EU - actual date of the border crossing;  for containers - actual date of the ship extractor",
      expecteddelivery:
        "Expected delivery date is the scheduled date of delivery by the manager",
      deliveryscheduled:
        "Delivery scheduled is scheduled delivery date by logist",
      unloadingfact: "Unloading fact - actual unloading date",
      bodySize: "Size car",

      reportorder:
        "Дані вибираються з Рейсів ТС за вибраний період, і пошук даних в таблиці відбуваються лише по вибраним даним.",
      reportfind:
        "Пошук даних відбувається лише по таблиці, запит в БД не відбувається.",
      selectorder: "Введіть останні 4 цифри ордера",
      selectarticle: "Пошук відбувається по артикулу",

      tree: [],

      props: {
        stripe: false,
        border: false,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: true,
        isFold: true,
        expandType: false,
        selectionType: false
      },
      score: 10,

      columns: [{}],

      columsSelections: [],
      columsGroupArray: [],
      columsFilters: [],

      columsGroup: [],

      findNumberOrder: null,
      typeReport: 0,
      selectionOrderByPallet: "",
      selectionNomenclatureByOrder: ""
    };
  },
  components: {
    'autocomplete': autocomplete,
    'my-table': MyTable,

  },
  methods: {    
    showOrdertDetail(item){
     this.$modals.show("order-detail")
     this.getTranscriptOrder(item.order);
      this.creatingFildsTable();

      this.showTable = false;
      this.showTableTranscriptOrder = true;
    },
    showOrderInPallet(item){
     this.$modals.show("order-in-pallet")
     this.clickNextTable(item.order);
      // this.creatingFildsTable();
      // this.showTable = false;
      this.showTableTranscriptOrder = true;
    },
    showOrderSumItem(item){
     this.$modals.show("order-sub-desk")
     this.clickNextTableTranscriptOrder(item.orderForProduction);
      // this.creatingFildsTable();
      // this.showTable = false;
      this.showTableTranscriptOrder = true;
    },
    showTransportDetail(item){
      console.log(item)
    },
    goToRef(item){
      console.log(item)
      this.descTablesData = item;
      this.anchorTo("desc")
      $('#collapse41').collapse('hide')
    },
    reportSee() {
      let dataRequest = {
        guidClient: null,
        dataStart: this.report.dataFrom,
        dataEnd: this.report.dataTo,
        frontOffice: this.report.frontoffice,
        guidClient: localStorage.getItem("guidClient"),
      };
      this.makeQuery("/report/gettransportapplication", {
        dataRequest: dataRequest,
        token: localStorage.getItem("user-token"),
      })
        .then((res) => {
          this.result = res.data;
          this.oldresult = res.data;
          this.collapsed = false;
          this.typeReport = 1;
          $('#collapse41').collapse('hide');
        })
        .catch((err) => console.error(err));
    },
    getFrontOffice() {
      this.loading = true;
      let dataRequest = { guidClient: null };
      dataRequest.guidClient = localStorage.getItem("guidClient");
      this.makeQuery("/report/getfrontoffice", {
        dataRequest: dataRequest,
        token: localStorage.getItem("user-token"),
      })
        .then((res) => {
          this.report.frontoffice = res.data.listFrontOffice;
          this.loading = false;
        })
        .catch((err) => console.error(err));
    },
    getDateTo() {
      const toTwoDigits = (num) => (num < 10 ? "0" + num : num);
      let today = new Date();
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());

      return `${year}-${month}-${day}`;
    },

    getDateFrom() {
      const toTwoDigits = (num) => (num < 10 ? "0" + num : num);
      let today = new Date();
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate()) - 2;

      let strDay = "" + day;

      if (strDay.length == 1) {
        day = "0" + day;
      }

      return `${year}-${month}-${day}`;
    },
        //sorting fields table
    sortTable: function(sortKey) {
      if (this.sortOrders[sortKey] == 0) {
        this.sortOrderBy = 1;
        this.sortOrders[sortKey] = 1;
        this.result = this.result.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          if (a > b) return -1;
          if (a < b) return 1;
          return 0;
        });
      } else if (this.sortOrders[sortKey] == 1) {
        this.sortOrderBy = 0;
        this.sortOrders[sortKey] = 0;
        this.result = this.result.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      }
    },

    //change cooment
    changeComment: function(tc, comment) {
      this.postComment(tc, comment);
    },

    //filter table main
    filterTable: function() {
      var filterKey = this.keysearch && this.keysearch.toLowerCase();
      if (filterKey) {
        this.result = this.oldresult.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      } else {
        this.result = this.oldresult;
      }
    },

    //filter table description
    filterTableDescription: function() {
      var filterKey = this.keysearch && this.keysearch.toLowerCase();
      if (filterKey) {
        this.dataFields = this.oldDataFields.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      } else {
        this.dataFields = this.oldDataFields;
      }
    },

    //show fild filtr
    showFilterField: function() {
      if (this.filterfield) {
        this.filterfield = false;
      } else {
        this.filterfield = true;
      }
    },

    //show fild filtr
    showSelectionsField: function() {
      if (this.selectionfield) {
        this.selectionfield = false;
      } else {
        this.selectionfield = true;
      }
    },
    //find transpor by order
    findOrder() {
      this.loading = true;
      axios
        .post("/api/orders/findOrderTransport", {
          numberOrder: this.selection,
          numberCustomsOrder: this.selectionCustomsOrder
        })
        .then(res => {
          this.result = res.data[0];
          this.oldresult = res.data[0];
          this.loading = false;
          this.collapsed = false;
          this.typeReport = 2;
        })
        .catch(err => console.error(err));
    },
    //get description main table
    getTranscriptOrder(number) {      
      this.selectionOrder = number;
      let dataRequest = {       
        guidClient : localStorage.getItem('guidClient'),
        order: number
        };     
      this.makeQuery("/report/gettranscriptordertransport", {dataRequest : dataRequest, token: localStorage.getItem('user-token'), order: number })
        .then(res => {
          this.dataFields = res.data;
          this.oldDataFields = res.data;
          
          this.collapsed = false;
        })
        .catch(err => console.error(err));
    },
    getListCustomsOrder(value) {
      listOrder: [];
      if (value.length > 3) {
        axios
          .post("/api/orders/getListCustomsOrder", {
            order: value
          })
          .then(res => {
            this.listCustomsOrder = res.data[0];
          })
          .catch(err => console.error(err));
      }
    },
    getListOrder(value) {
      listOrder: [];
      if (value.length > 3) {
        axios
          .post("/api/orders/getListOrder", {
            order: value
          })
          .then(res => {
            this.listOrder = res.data[0];
          })
          .catch(err => console.error(err));
      }
    },
    getListNomenclature(value) {
      listNomenclature: [];
      if (value.length > 3) {
        axios
          .post("/api/orders/getListNomenclature", {
            nomenklature: value
          })
          .then(res => {
            this.listNomenclature = res.data[0];
          })
          .catch(err => console.error(err));
      }
    },
    creatingFildsTable() {},
     clickNextTable(event) {
      this.getTranscriptOrderDetalisByPallet(event);
      // this.showTableTranscriptOrder = false;
      this.showTableTranscriptOrderByPallet = true;
    },

    clickNextTableTranscriptOrder(event) {
      this.getNomenclaturByOrder(event);
      // this.showTableTranscriptOrder = false;
      this.showTableTranscriptOrderClientDetalis = true;
    },
     hideTableMain: function(number) {
      this.getTranscriptOrder(number);
      this.creatingFildsTable();

      this.showTable = false;
      this.showTableTranscriptOrder = true;
    },
    showTableMain: function() {
      this.showTable = true;
      this.showTableTranscriptOrder = false;
    },

    backShowTableTranscriptOrder: function() {
      this.showTableTranscriptOrder = true;
    },

    backShowTransciptOrderClient: function() {
      this.showTableTranscriptOrderDetalis = false;
      this.showTableTranscriptOrderClientDetalis = false;
      this.showTableTranscriptOrderByPallet = false;
      this.showTableNomenclatureByPallet = false;
      this.showTableTranscriptOrder = true;
    },

    hideTableMain: function(number) {
      this.getTranscriptOrder(number);
      this.creatingFildsTable();

      this.showTable = false;
      this.showTableTranscriptOrder = true;
    },
    getTranscriptOrderDetalisByPallet(event) {
      this.dataFieldsOrderByPallet = [];
      this.oldDataFieldsOrByPallet = [];
      let dataRequest = {
        order: event        
      };
      this.makeQuery("/report/getnomenclaturbypallet", {
        dataRequest: dataRequest,
        token: localStorage.getItem("user-token"),
      })
      .then(response => {
          this.dataFieldsOrderByPallet = response.data;
          this.oldDataFieldsOrByPallet = response.data;
          this.selectionOrderByPallet = event;          
          this.collapsed = false;
        })
        .catch(err => console.error(err));
    },
     getNomenclaturByOrder(event) {
        let dataRequest = {
        order: event        
      };
      console.log(dataRequest)
      this.makeQuery("/report/getnomenclaturebyorder", {
        dataRequest: dataRequest,
        token: localStorage.getItem("user-token"),
      })
        .then(response => {
          this.dataFieldsOrderClient = response.data;
          this.oldDataFieldsOrderClient = response.data;
          this.selectionNomenclatureByOrder = event;

          this.loading = false;
          this.collapsed = false;
        })
        .catch(err => console.error(err));
    },
// save file

base64String(file, data){
            let mediatype = '';
            
            const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
              const byteCharacters = atob(b64Data);
              const byteArrays = [];

              for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
              }

              const blob = new Blob(byteArrays, {type: contentType});
              return blob;
            }

            if (file.indexOf('.xlsx') > -1) {
              mediatype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            } else if (file.indexOf('.xls') > -1) {
              mediatype = 'application/vnd.ms-excel';
            } else if(file.indexOf('.txt') > -1) {
              mediatype = 'text/plain';
            } else if(file.indexOf('.xml') > -1) {
              mediatype = 'text/xml';
            } else if ((file.indexOf('.png') > -1)||(file.indexOf('.jpg') > -1)||(file.indexOf('.jpeg') > -1)||(file.indexOf('.png') > -1)) {
              mediatype = 'image/png';
            } else if (file.indexOf('.pdf') > -1) {
              mediatype = 'application/pdf';
            } else if (file.indexOf('.doc') > -1) {
              mediatype = 'application/msword';
            } else if (file.indexOf('.docx') > -1) {
              mediatype = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else if (file.indexOf('.gz') > -1) {
              mediatype = 'application/gzip';
            } else if (file.indexOf('.rar') > -1) {
              mediatype = 'application/vnd.rar';
            } else if (file.indexOf('.tar') > -1) {
              mediatype = 'application/x-tar';
            } else if (file.indexOf('.ppt') > -1) {
              mediatype = 'application/vnd.ms-powerpoint';
            } else if (file.indexOf('.pptx') > -1) {
              mediatype = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            } else if (file.indexOf('.vsd') > -1) {
              mediatype = 'application/vnd.visio';
            } else if (file.indexOf('.zip') > -1) {
              mediatype = 'application/zip';
            }

            if(mediatype != ''){
              return b64toBlob(data, mediatype)//'data:' + mediatype + ';base64,';
            } else {
              return null;
            }

          },


 bringfile(fileName){
            for (let i = 0; i < this.dataEquipment.instructions.length; i++) {
              if((fileName == this.dataEquipment.instructions[i].name) && (this.dataEquipment.instructions[i].data != null)){
                fileDownload(this.dataEquipment.instructions[i].data, fileName);
                return
              }
            }
            let dataRequest = {codeModel: this.dataEquipment.model, nameFile: fileName};
            this.makeQuery("/service/getproductinctruction",{dataRequest: dataRequest})
            .then(res => {
                if(res != null){

                  if ((res.data.length > 0) && (typeof res.data != 'string')){
                    for (let i = 0; i < res.data.length; i++) {
                      
                      for (let j = 0; j < this.dataEquipment.instructions.length; j++) {
                        if((res.data[i].name == this.dataEquipment.instructions[j].name) &&
                          ((res.data[i].data != undefined)||(res.data[i].data != null))){
                          
                          this.dataEquipment.instructions[j].data = this.base64String(fileName, res.data[i].data);// + res.data[i].data;
                          if(this.dataEquipment.instructions[j].data != null){
                            fileDownload(this.dataEquipment.instructions[j].data, fileName);
                            break
                          } else {
                            this.showNotification('custom-info','Instructions','Not allowed Type of file ' + fileName + ', contact Modern ASU!');
                            break;
                          }
                        } if((res.data[i].name == this.dataEquipment.instructions[j].name) &&
                          ((res.data[i].data == undefined)||(res.data[i].data == null))){
                          this.showNotification('custom-info','Instructions','No file there!');
                          break
                        }
                      }
                      
                    }
                  }
                }
            });
          },



     saveToExcel(idTable) {
      if (idTable == 1) {
        if (this.typeReport == 1) {
          let dataRequest = {       
          guidClient : localStorage.getItem('guidClient'),
          dataStart : this.report.dataFrom,
          dataEnd : this.report.dataTo,
          frontOffice : this.report.frontoffice
          }
          this.makeQuery("/report/gettranscriptordertransport", {dataRequest : dataRequest, token: localStorage.getItem('user-token') })
          .then(res => {
          console.log(res.data);
         
        })
        .catch(err => console.error(err));
          };   
                  
        
        
        if (this.typeReport == 0) {
          var dataStart = this.report.dataFrom;
          var dataEnd = this.report.dataTo;
          var frontOffice = this.report.frontoffice;
          window.location.href =
            "/api/orders/exportGlobalTableJS/" +
            dataStart +
            "/" +
            dataEnd +
            "/" +
            frontOffice;
             }
        if (this.typeReport == 2) {
          var numberOrder = this.selection;
          var numberCustomsOrder = this.selectionCustomsOrder;
          window.location.href =
            "/api/orders/exportGlobalTableByOrder/" + numberOrder;
        }
      }

      if (idTable == 2) {
        var numberOrder = this.selectionOrder;
        window.location.href =
          "/api/orders/exportTranscriptOrder/" + numberOrder;
      }

      if (idTable == 3) {
        var numberOrder = this.selectionOrderByPallet;
        window.location.href =
          "/api/orders/exportNomenclaturByPallet/" + numberOrder;
      }

      if (idTable == 4) {
        var numberOrder = this.selectionNomenclatureByOrder;
        window.location.href =
          "/api/orders/exportNomenclaturByOrder/" + numberOrder;
      }
    },
// and save to exl
     showModalMap: function (order) {
          this.getPositionCar(order)
          this.$modals.show("map-modal")
      },
      closeModal(name){
        console.log(name)
        // this.$modals.hide(name);
      },
      closeModalMap: function () {
          this.list = [];
           this.center = { lat: 50.761871, lng: 25.3562243 };
          this.$modals.hide("map-modal");
      },
    
      getPositionCar(order) {
        let dataRequest = {
        orders: order ,       
        guidClient: localStorage.getItem("guidClient")
        };
        this.makeQuery("/report/getpositioncar", {
          dataRequest: dataRequest,
          token: localStorage.getItem("user-token"),
        })
        .then(res => {
        this.list = [res.data];
        this.center = res.data;  
        // console.log("dd343333");
      //  addr = this.geocodedAddress();
        //console.log(addr);
      })
      .catch(e => {
          this.$noty.error("Помилка отримання координат з сервера. Спробуйте за декілька хвилин.")
          this.loading = false
      });
       },
  },  
  created() {
    this.getFrontOffice();
    this.report.dataFrom = this.getDateFrom();
    this.report.dataTo = this.getDateTo();
  },
  mounted() {},
   computed:{
      userRole(){
        if(this.$store.getters.getUserRoleAdmin){
            return  "admin"    
        }
        else if (this.$store.getters.getUserRoleLogist) {             
          return "logist"
        }
        else if (this.$store.getters.getUserRoleClient) {             
          return "client"
        }
        else return "user"      
      },
    },
};
</script>
<style>
.v-modal__content {    
    width: 80% !important;   
}
</style>
<style scoped>
#transport-request {
   font-family: Inter,sans-serif!important;
   font-size: 0.8rem;
}
.order-desc{
  color: #666;
  font-weight: bold;
}
.badge {
  white-space:normal
}
.sicon {
  font-size: 14px;
}
.link {color: rgb(98, 138, 224);}
.cursor {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.action-icon {
  cursor: pointer;
  margin: 5px 10px;
  width: 40px;
  height: 40px;
  }
.main-tables a {
  font-size:12px;
}
.card-header .card-title {
  text-transform:none;
}

.is-collapsed {
    display: none;
}

.is-collapsed-appreciated {
  background: #cfceba;
}

.is-collapsed-scheduled {
  background:  #e5e194;
}

.is-collapsed-preparedTransport {
  background: #94e5dc;
}

.is-collapsed-sent {
  background: #44cf53;
}

.arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 0.9;
    }
.arrow.dsc {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
}
.arrow.asc {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
}

/* tables-scroll */
.table-scroll {
  position: relative;
  width:100%;
  z-index: 1;
  margin: auto;
  overflow: auto;
  height: 400px;
}
.table-scroll table {
  width: 100%;
  min-width: 1280px;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
}
.table-wrap {
  position: relative;
}
.table-scroll th,
.table-scroll td {
  padding: 5px 10px;
  border: 1px solid rgb(223, 211, 211);
  background: #fff;
  border-bottom: 2px solid #e3ebf3;
    border-top: 1px solid #e3ebf3;
  vertical-align: top;
}
#table-scroll thead th {
  background: rgb(226, 222, 222);
  color: #fff;
  border-bottom: 2px solid #e3ebf3;
    border-top: 1px solid #e3ebf3;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
/* safari and ios need the tfoot itself to be position:sticky also */
.table-scroll tfoot,
.table-scroll tfoot th,
.table-scroll tfoot td {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background: #666;
  color: #fff;
  z-index:4;
}


.table-scroll
th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #ccc;
}
#table-scroll tbody tr td:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 2;
  background: rgb(235, 230, 230);
}
.table-scroll thead th:first-child,
.table-scroll tfoot th:first-child {
  z-index: 5;
}
#table-scroll .condition {
  background-color: #f38682;
}
.outer{
    overflow-y: auto;
    height:600px;
    }

.outer table{
    width: 100%;
    table-layout: fixed; 
    /* border : 1px solid black; */
    border-spacing: 1px;
}

.outer table th {
        text-align: left;
        top:0;
        position: sticky;
        background-color: white;  
}
#order-in-pallet .v-modal__content {    
    width: 80%;   
}
.modal-detail a, .order-in-pallet a, .order-sub-desk a {
  font-size: 1rem;
  margin-left: 1px;
}

@media (max-width: 730px) {
  .table-scroll {  
  height: 300px;
}

    }
  .filter-head {
    padding: 5px 5px;
  }
.filter-form {
   padding: 5px 5px;
   margin-bottom: 15px;
}
.content-filter {
  padding: 10px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.smal {
  width: 80px;
}
/* and tables */
</style> 


// WEBPACK FOOTER //
// src/pages/Transport_request.vue